const experienceData = [
  {
    id: 5,
    title: "Web-developer - soaprevent.eu",
    duration: "May 2025 - Current",
    projectNumber: "5",
    techs: [
      "TypeScript",
      "NextJs",
      "React Js",
      "PostgreSQL",
      "Redux",
      "jsx",
      "Functional component",
      "Scss",
      "Tailwind",
      "Material UI",
      "Bootstrap",
      "Daisy UI",
      "Charts",
      "Vs Code",
      "Cypress",
      "cloudflare",
      "cloudflare workers",
      "D1 databases",
      "Google Developer Tools",
      "HTTP",
      "Axios",
      "Gitlab",
      "EsLint",
      "NPM",
      "NVM",
    ],
    responsibilities: [
      "Develop and maintain Next.js and React applications, working on both full-stack and frontend features as needed.",
      "Advise on best practices and emerging technologies to enhance product quality and scalability.",
      "Collaborate closely with designers and backend developers to implement pixel-perfect UI designs and integrate APIs.",
      "Optimize application performance through code-splitting, lazy loading, and other performance enhancement techniques.",
      "Contribute to building and maintaining reusable UI components to improve development efficiency and ensure design consistency.",
    ],
  },
  {
    id: 4,
    title: "Freelance | Parental Break",
    duration: "December 2023 - Current",
    projectNumber: "5",
    techs: [
      "TypeScript",
      "React Js",
      "Vue 3",
      "Angular,",
      "PostgreSQL",
      "Redux",
      "Express Js",
      "RxJs",
      "Html",
      "Markdown",
      "Scss",
      "Bootstrap",
      "Tailwind",
      "Vs Code",
      "Cypress",
      "Google Developer Tools",
      "HTTP",
      "Hugo Framework",
      "Firebase",
      "Axios",
      "Github",
      "Github actions",
      "Vite",
      "EsLint",
      "NPM",
      "NVM",
    ],
    responsibilities: [
      "Visited India after 4 years.",
      "learned Slovene language and Passed A1 level test.",
      "Making some independent projects , for details checkout my Github.",
      "Supported and took care of my wife and welcomed a new family member.",
    ],
  },
  {
    id: 3,
    title: "Frontend Developer-XLAB doo",
    duration: "June 2022 - 1st Dec 2023",
    projectNumber: "6",
    techs: [
      "TypeScript",
      "Vue JS,",
      "Angular,",
      "React Js",
      "Jira",
      "Docker",
      "Cypress",
      "Html",
      "Markdown",
      "Scss",
      "Css",
      "JQuery",
      "Java Script",
      "Bootstrap",
      "Vs Code",
      "Gitlab,",
      "Google Developer Tools",
      "Hugo Framework",
      "GO Templating",
      "Adobe XD",
    ],
    responsibilities: [
      "Contributed to development of responsive enterprise-level web applications using VueJs, React and Angular in a team of 3 engineers.",
      "Independently collaborated with designers and backend developers to implement pixel-perfect UI designs and integrate backend APIs.",
      "Optimized application performance by implementing code-splitting, lazy loading, and other performance optimization techniques.",
      "Contributed to the development of reusable UI components to improve development efficiency and maintain consistency across the application.",
      "Independently migrated company's website from WordPress (PHP templating) to Hugo (Golang templating) and contributed to Django backend.",
      "Worked closely with QA team to identify and fix bugs.",
    ],
  },
  {
    id: 2,
    title: "Web-developer - Soft Smart Services",
    duration: "Aug 2015 - Dec 2021",
    projectNumber: "30+",
    techs: [
      "React",
      "Html",
      "Scss",
      "Css",
      "JQuery",
      "Java Script",
      "Php",
      "Sql",
      "Figma",
      "Bootstrap",
      "Google Developer Tools",
      "Github",
      "Google Adwords",
      "Google Analytics",
      "Wordpress",
      "Woo-commerce",
    ],

    responsibilities: [
      "Collaborated on React projects, creating dynamic, user-friendly interfaces.",
      "Developed websites using Html, CSS, bootstrap, JavaScript, jQuery, PHP and SQL.",
      "Created and suggested website designs.",
      "Made SEO friendly websites.",
      "Manage website backend and hosting",
    ],
  },
  {
    id: 1,
    title: "Software support - In Technologies",
    duration: "Apr 2013 - 2014",
    projectNumber: "None",
    responsibilities: [
      "Software troubleshooting support for USA/CA/Britain clients.",
    ],
  },
];
const sliderImages = [
  {
    slide: "images/slideImages/frankfurt.jpeg",
    place: "Frankfurt, Germany",
  },
  { slide: "images/slideImages/x1.png", place: "Ljubljana, Slovenia" },
  { slide: "images/slideImages/werdev.jpg", place: "Berlin, Germany" },
  {
    slide: "images/slideImages/munich.jpeg",
    place: "München, Germany",
  },
  {
    slide: "images/slideImages/Belgium.jpeg",
    place: "Brussels, Belgium",
  },
  { slide: "images/slideImages/x2.jpg", place: "Ljubljana, Slovenia" },
  { slide: "images/slideImages/x3.jpg", place: "Ljubljana, Slovenia" },
  { slide: "images/slideImages/france.jpeg", place: "Paris, France" },
  {
    slide: "images/slideImages/venice.jpeg",
    place: "Venice, Italy",
  },
];

export { experienceData, sliderImages };
